// extracted by mini-css-extract-plugin
export var attachmentContainer = "_jj-0";
export var fileList = "_jj-2";
export var removeFileButton = "_jj-1";